import { motion } from 'framer-motion';
import { PRACTICES, PARTNERS } from './data';

// PRACTICE — three practices presented as numbered chapters, NOT card grid.
export default function Practice() {
  return (
    <div className="bg-[#EFEAE0] text-[#1B1A18]">
      <section className="pt-12 pb-10 max-w-[1500px] mx-auto px-8 lg:px-14 border-b-2 border-[#1B1A18]/30">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#142437] mb-4">— Section II · Practice</p>
        <h1 className="font-serif text-5xl lg:text-8xl leading-[0.92] tracking-[-0.02em] max-w-5xl">Three things, <span className="italic text-[#142437]">done well</span>.</h1>
      </section>

      <section className="max-w-[1300px] mx-auto px-8 lg:px-14 py-20 space-y-20">
        {PRACTICES.map((p, i) => (
          <motion.article key={p.id} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}
            className="grid lg:grid-cols-[180px_1fr_240px] gap-8 lg:gap-16 border-t border-[#1B1A18]/20 pt-12">
            <div>
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#142437]">/ Practice {p.id}</p>
              <p className="font-serif text-7xl lg:text-8xl text-[#142437] leading-none mt-2">{p.id}</p>
            </div>
            <div>
              <h2 className="font-serif text-4xl lg:text-6xl leading-[1] mb-5">{p.t}</h2>
              <p className="font-serif text-lg lg:text-xl text-[#1B1A18]/85 leading-[1.65]" dangerouslySetInnerHTML={{ __html: p.d }} />
            </div>
            <div className="lg:border-l border-[#1B1A18]/15 lg:pl-8">
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#142437]">Coverage</p>
              <p className="font-serif text-2xl text-[#142437] mt-2">{p.staff}</p>
              <p className="font-mono text-[11px] text-[#1B1A18]/45 mt-2">All on the partnership ledger</p>
            </div>
          </motion.article>
        ))}
      </section>

      {/* Partners ledger — table treatment */}
      <section className="border-y border-[#1B1A18]/15 bg-[#E5DDC9]">
        <div className="max-w-[1300px] mx-auto px-8 lg:px-14 py-20">
          <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#142437] mb-4">— The partnership · principal partners</p>
          <h2 className="font-serif text-3xl lg:text-5xl mb-10 leading-tight">Forty-six partners, <span className="italic text-[#142437]">named in the deed</span>.</h2>
          <table className="w-full font-serif">
            <tbody>
              {PARTNERS.map((p, i) => (
                <tr key={p.name} className={`border-b border-[#1B1A18]/15 ${i === 0 ? 'border-t' : ''}`}>
                  <td className="py-7 pr-6 align-top w-12 font-mono text-[10px] tracking-[0.25em] uppercase text-[#142437]">0{i + 1}</td>
                  <td className="py-7 pr-6 align-top">
                    <p className="text-2xl lg:text-3xl leading-tight">{p.name}</p>
                    <p className="font-serif italic text-base text-[#1B1A18]/55 mt-1">{p.role}</p>
                  </td>
                  <td className="py-7 align-top text-base text-[#1B1A18]/75 leading-[1.65] hidden md:table-cell max-w-md">{p.bio}</td>
                </tr>
              ))}
              <tr><td colSpan="3" className="py-6 font-mono text-[11px] text-[#1B1A18]/45 italic text-center">+ 43 further partners</td></tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
